import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Autocomplete from 'react-autocomplete';
import moment from 'utils/moment';
import PulpoField from '../../../../pulpo_visualizer/fields';
import styles from './Approvals.module.scss';
import Panel from '../../../../components/panel';
import Button from '../../../../components/button';
import CustomFields from '../../../../components/customFields/CustomFields';
import fieldstyles from '../../../../pulpo_visualizer/fields/fields.module.scss';
import Attachments from '../../components/Attachments';
import CloseIcon from '../../../../icons/close.svg';
import Modal from '../../../../components/modal';
import StepInfoBox from './StepInfo';
import CollapsibleSections from '../../../../components/customFields/CollapsibleSections';

class StepForm extends Component {
  state = { currentValue: undefined, openRemarks: false, rejectionRemarks: '', remarksError: false, remarksType: '' };

  static getDerivedStateFromProps(props, state) {
    if (props.info?.completed_by?.id && state.currentValue === undefined) {
      return { ...state, currentValue: props.info.completed_by.fullname };
    }
    return state;
  }

  handleAutocompleteChange = (e) => {
    const { searchForUser } = this.props;
    this.setState({ currentValue: e.target.value });
    searchForUser(e.target.value);
  };

  handleAutocompleteSelect = (val, item) => {
    const { handleAnswerChanged, handleFieldErrorChanged } = this.props;

    this.setState({ currentValue: val });
    handleAnswerChanged(item, 'completed_by');
    handleFieldErrorChanged('completed_by', false);
  };

  handleDrop = (dropped) => {
    const { handleAnswerChanged, info } = this.props;
    handleAnswerChanged([...info.attachments, ...dropped], 'attachments');
  };

  handleRemoveImage = (r) => {
    const { handleAnswerChanged, info } = this.props;
    const res = info.attachments.filter(e => e !== r);
    handleAnswerChanged(res, 'attachments');
  };

  handleRejectionPopup = (actionType) => {
    this.setState({ openRemarks: true, remarksType: actionType });
  }

  handleSaveremarks = () => {
    const { handleReject, handleSendBack } = this.props;
    const { rejectionRemarks, remarksType } = this.state;
    if (rejectionRemarks) {
      if (remarksType === 'reject') {
        handleReject({ remarks: rejectionRemarks, rejected_date: moment().format() });
      } else if (remarksType === 'send_back') {
        handleSendBack({ remarks: rejectionRemarks, send_back_date: moment().format() });
      }
    } else {
      this.setState({
        remarksError: true
      });
    }
  }

  handleDisabledApprove = (buttonType) => {
    const { info, step } = this.props;
    const conditionalKey = step?.[buttonType]?.condition_field?.key;
    const conditionalFieldValues = step?.[buttonType]?.condition_field_values || [];
    let isValue = true;
    let haveAnswers = info || {};
    if (conditionalKey) {
      isValue = false;
    }
    if (typeof haveAnswers[conditionalKey] === 'string') {
      isValue = conditionalFieldValues.filter(
        value => haveAnswers[conditionalKey] === value.value
      ).length > 0;
    }
    return !isValue;
  }

  getStepFields = (steps = []) => steps.filter((field) => {
    const startsWithEx = field.id.startsWith('ex');
    const exposedId = !!field?.meta_data?.exposedId;
    // Old ExposeField: meta_data.exposedId is NOT present → keep field
    const isOldExposeField = startsWithEx && exposedId === undefined;
    // New ExposeField: exposedId exists → keep only if true
    const isExposed = startsWithEx && exposedId;
    // Normal fields: Id does not start with 'ex'
    const isNormalField = !startsWithEx;
    return isNormalField || isOldExposeField || isExposed;
  });

  render() {
    const { currentValue, openRemarks, rejectionRemarks, remarksError, remarksType } = this.state;
    const {
      handleAnswerChanged,
      showFormErrors,
      handleFieldErrorChanged,
      handleUploadAttachments,
      userlist,
      info,
      handleSubmit,
      errorsList,
      step,
      requiredMap,
      collpaseAll,
      handleCheckListAnswer,
      form_entry_data,
      formAnswerSettings,
      formApprovalProcess,
      processStep,
      formEntryDetails,
      profile,
      errorListMCG,
      locationList,
      fieldErrors
    } = this.props;

    let modalBtns = {
      'id': step?.reject_title || 'form.step.reject',
      'title': step?.reject_title || 'Reject'
    };
    if (remarksType === 'send_back') {
      modalBtns = {
        'id': step?.sendback_title || 'forms.new.enable_send_back',
        'title': step?.sendback_title || 'Send Back'
      };
    }

    const sectionHeaders = step?.fields?.filter(field => field.type === 'header') || [];
    const currentApproval = formApprovalProcess?.filter(
      eachApp => eachApp?.step_id === step?.id && eachApp?.logged_by?.id !== profile?.id && eachApp?.status === 'complete'
      && !processStep?.info?.send_back_ids?.includes(eachApp?.id)
    );

    const getCustomFieldComponent = fields => (
      <CustomFields
        handleAnswerChanged={handleAnswerChanged}
        handleFieldErrorChanged={handleFieldErrorChanged}
        showFormErrors={showFormErrors}
        requiredMap={requiredMap}
        errorsList={errorsList}
        placeHolders={[]}
        fields={fields || []}
        answers={info}
        handleUploadAttachments={handleUploadAttachments}
        handleCheckListAnswer={handleCheckListAnswer}
        form_entry_data={form_entry_data}
        formApprovalProcess={formApprovalProcess}
        formTabFeilds={step?.fields || []}
        processStep={processStep}
        myformApprovals
        formApprovalSteps
        formEntryDetails={formEntryDetails}
        errorListMCG={errorListMCG}
        formEntryFields={step?.fields || []}
        fromForms
        myforms
        fieldPropStyles={styles.customFieldContent}
        globalLocationList={locationList}
        fieldErrors={fieldErrors}
      />
    );

    return (
      <Panel
        title={step?.title || 'Approval'}
        contentClasses={styles.panelContainer}
      >
        {currentApproval?.map(item => (
          <div style={{ marginBottom: '10px', width: '95%' }}>
            <StepInfoBox
              info={item || {}}
              step={step}
              profile={profile}
              collpaseAll={collpaseAll}
              collapsibleTitle={item?.logged_by?.fullname}
              formAnswerSettings={formAnswerSettings}
              form_entry_data={form_entry_data}
              formApprovalProcess={formApprovalProcess}
            />
          </div>
        ))}
        <div
          style={{ overflowY: 'auto' }}
          className={styles.stepFormContainer}
        >
          <div
            className={`${styles.stepForm}`}
            style={{ height: 'auto', marginLeft: '10px' }}
          >
            <div className={fieldstyles.field}>
              <FormattedMessage
                id="form.approve.completed_by"
                defaultMessage="Completed by"
              >
                {txt => (
                  <span className={fieldstyles.title}>
                    <small style={{ color: 'red', display: 'inline' }}> * </small>
                    {txt}
                  </span>
                )}
              </FormattedMessage>
              <Autocomplete
                getItemValue={item => item.fullname}
                items={userlist}
                wrapperStyle={{ position: 'relative', overflow: 'hidden', pointerEvents: 'none' }}
                value={currentValue}
                onChange={() => ({})}
                onSelect={() => ({})}
                renderMenu={children => (
                  <div className={styles.autocompleteMenu}>{children}</div>
                )}
                renderItem={(item, isHighlighted) => (
                  <div
                    key={item.id}
                    className={`${styles.menuItem} ${isHighlighted
                      && styles.highlighted}`}
                  >
                    {item.fullname}
                  </div>
                )}
              />
              {!currentValue && showFormErrors && (
                <small>
                  <FormattedMessage
                    id="pulpoforms.errors.not_blank"
                    defaultMessage="There is an error in this field"
                  />
                </small>
              )}
            </div>
            <div style={{ width: '45%' }}>
              <PulpoField
                key="completed_date"
                id="completed_date"
                type="datetime"
                translationID="form.approve.date"
                title="Completed Date and Time" isRequired
                handleValueChange={handleAnswerChanged}
                answer={info.completed_date}
                showFieldErrors={showFormErrors}
                handleFieldErrorChanged={handleFieldErrorChanged}
                myforms
                disabled
              />
            </div>
          </div>
          <div
            className={styles.customField}
            style={{ marginTop: '0px', marginLeft: '10px', flexDirection: 'column' }}
          >
            {(requiredMap && sectionHeaders?.length > 0 && step?.fields?.length > 0)
            && <CollapsibleSections
                fieldsList={this.getStepFields(step?.fields)}
                getCustomFieldComponent={getCustomFieldComponent}
                formatStyle
                answers={info} />}
            {(requiredMap && !sectionHeaders?.length > 0 && step?.fields?.length > 0) && (getCustomFieldComponent(this.getStepFields(step?.fields)))}
          </div>
          <div
            className={`${styles.stepForm}`}
            style={{ height: 'auto', marginTop: '0px' }}
          >
            <PulpoField
              key="comment" id="comment"
              type="string"
              className={styles.fullInput}
              widget={{ type: 'textarea' }}
              translationID="form.step.remarks"
              title="Remarks/Comments"
              handleValueChange={handleAnswerChanged}
              answer={info.comment}
              showFieldErrors={showFormErrors}
              handleFieldErrorChanged={handleFieldErrorChanged}
            />
            <div className={styles.fullInput}>
              <Attachments
                key="attachments" id="attachments"
                type="attachments"
                translationID="description"
                title="Attachments"
                handleAnswerChanged={handleAnswerChanged}
                attachments={info.attachments}
                showFieldErrors={showFormErrors}
                handleFieldErrorChanged={handleFieldErrorChanged}
              />
            </div>
          </div>
          <div className={styles.separator} />
        </div>
        <div className={styles.stepFooter}>
          <Button
            onClick={() => handleSubmit(false)}
            translationID={step?.approve_title || 'form.step.approve'}
            defaultText={step?.approve_title || 'Approve'}
            action="approve"
            disabled={this.handleDisabledApprove('approve_button_condition')}
          />
          {step?.send_back_to && (
            <Button
              onClick={() => this.handleRejectionPopup('send_back')}
              translationID={step?.sendback_title || 'forms.new.enable_send_back'}
              defaultText={step?.sendback_title || 'Send Back'}
              action="secondary"
              disabled={this.handleDisabledApprove('send_back_button_condition')}
            />
          )}
          {step?.enable_reject && (
            <Button
              onClick={() => this.handleRejectionPopup('reject')}
              translationID={step?.reject_title || 'form.step.reject'}
              defaultText={step?.reject_title || 'Reject'}
              action="danger"
              disabled={this.handleDisabledApprove('reject_button_condition')}
            />
          )}
          {step?.enable_saveDraft && (
            <Button
              onClick={() => handleSubmit(true)}
              translationID={step?.save_draft || 'inspections.complete_inspections.save_as_draft'}
              defaultText={step?.save_draft || 'Save as Draft'}
              action="tertiary"
              disabled={this.handleDisabledApprove('draft_button_condition')}
            />
          )}
        </div>
        {openRemarks && (
            <Modal
              onClose={() => this.setState({ openRemarks: false, rejectionRemarks: '' })}
              showIn={openRemarks}
              width="30%"
              minHeight="40%"
            >
              <div>
                <div className={styles.rejectionModalTitle}>
                  <FormattedMessage
                    id="workorders.remarks"
                    defaultText="Remarks"
                    tagName="h3"
                  />
                  <div className={styles.closeIcon} onClick={() => this.setState({ openRemarks: false })} role="presentation">
                    <img src={CloseIcon} alt="closeIcon" />
                  </div>
                </div>
                <div className={styles.rejectionModalContent}>
                  <PulpoField key="remarks" id="remarks" type="string" widget={{ type: 'textarea' }}
                    translationID="wildlife.form.remarks"
                    title="Remarks"
                    handleValueChange={a => this.setState({ rejectionRemarks: a })}
                    answer={rejectionRemarks}
                    showFieldErrors={remarksError}
                    handleFieldErrorChanged={handleFieldErrorChanged}
                    isRequired
                  />
                </div>
                <div className={styles.rejectionActionButton}>
                  <Button
                    translationID="workorders.list.filters.views.cancel"
                    defaultText="Cancel"
                    action="tertiary"
                    className={styles.cancelButton}
                    onClick={() => this.setState({ openRemarks: false, rejectionRemarks: '' })}
                  />
                  <Button
                    onClick={this.handleSaveremarks}
                    translationID={modalBtns?.id}
                    defaultText={modalBtns?.title}
                    action={remarksType === 'send_back' ? 'secondary' : 'danger'}
                  />
                </div>
              </div>
            </Modal>
          )
        }
      </Panel>
    );
  }
}

StepForm.propTypes = {
  info: PropTypes.shape({}).isRequired,
  handleAnswerChanged: PropTypes.func.isRequired,
  handleFieldErrorChanged: PropTypes.func.isRequired,
  showFormErrors: PropTypes.bool,
  userlist: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  searchForUser: PropTypes.func.isRequired,
  step: PropTypes.string.isRequired
};

StepForm.defaultProps = {
  showFormErrors: false
};

export default StepForm;
